<template>
    <div>
        <div class="cookies-body">
            <h2>Polityka plików cookie</h2>
            <div v-html="cookies" v-if="cookies">

            </div>
            <div v-else>
                <span>Ładowanie...</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { useMeta } from 'vue-meta';
export default{
    name:"CookiesVue",
    setup () {
    useMeta({
      title: 'Strona główna',
      meta: [{ name: 'robots', Name: 'robots', content: 'all' }]
    })
  },
    data(){
        return{
            cookies: ''
        }
    },
    props:{

    },
    mounted(){
        this.getStatuteData()
    },
    methods:{
        getStatuteData(){
            window.scrollTo(0,0)
            axios.get(`${process.env.VUE_APP_API_BASE_URL}CmsAll`)
                .then(res => {
                    this.cookies = res.data[2].content;
                })
        }
    }  
}
</script>

<style scoped>
.cookies-body{
    width: 90%;
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 10px;
    box-sizing: border-box;
    min-height: 500px;
}
</style>